import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Button,
  ControlledInput
} from '@hm/fundamental'
import {mdiClose, mdiCheck} from '@mdi/js'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type TaskResolvedMandatoryCommentProps = {
  'data-test-id': string
  open: boolean
  onClose: () => void
  onSubmit: (comment: string) => void
}

export const TaskResolvedMandatoryComment: React.FC<TaskResolvedMandatoryCommentProps> = ({
  'data-test-id': dataTestId,
  open,
  onClose,
  onSubmit
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const [mandatoryComment, setMandatoryComment] = useState<string>('')

  const handleCloseModal = () => {
    setMandatoryComment('')
    onClose()
  }

  return (
    <Modal open={open} onClose={handleCloseModal} data-test-id={dataTestId}>
      <ModalTitle>{t('task.label.changeTaskStatusTitle')}</ModalTitle>
      <ModalContent>
        {t('task.message.mandatoryCommentDescription')}
        <ControlledInput
          data-test-id={`${dataTestId}-input`}
          label={t('task.label.comments')}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setMandatoryComment(event.target.value)
          }
          className="mt-6"
          value={mandatoryComment}
        />
      </ModalContent>
      <ModalFooter>
        <Button
          type="button"
          variant="tertiary"
          size="regular"
          icon={mdiClose}
          iconPosition="left"
          onClick={handleCloseModal}
          data-test-id={`${dataTestId}-cancel-button`}
        >
          {t('task.action.cancel')}
        </Button>
        <Button
          type="button"
          variant="primary"
          size="regular"
          icon={mdiCheck}
          iconPosition="left"
          onClick={() => onSubmit(mandatoryComment)}
          disabled={!mandatoryComment}
          data-test-id={`${dataTestId}-submit-button`}
          className={!mandatoryComment ? '!bg-gray-400 !text-gray-700' : ''}
        >
          {t('task.action.confirm')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
